import script from "./HistoryRecord.vue?vue&type=script&lang=ts&setup=true"
export * from "./HistoryRecord.vue?vue&type=script&lang=ts&setup=true"

import "./HistoryRecord.vue?vue&type=style&index=0&id=2b80c8cc&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b80c8cc"]])

export default __exports__